import { action, observable } from "mobx";
import React from "react";
import { IButtonProps } from "../components";

export type IWithAlertStore = {
  $alertStore: AlertStore;
};

type IAlert = {
  title: string;
  type: "success" | "warning" | "error";
  body?: any;
  canIgnore?: boolean;
  prompt?: boolean;
  onIgnore?: () => void;
  positiveAction?: React.ReactElement<IButtonProps> | null;
  negativeAction?: React.ReactElement<IButtonProps> | null;
};

export class AlertStore {
  static injectKey = "$alertStore";

  @observable
  content$: IAlert = {
    title: "",
    type: "success",
    prompt: false,
    canIgnore: true,
  };

  @observable
  show$ = false;

  @action
  private reset = () => {
    this.show$ = false;
    this.content$ = {
      title: "",
      type: "success",
    };
  };

  @action
  showAlert = (content: IAlert): void => {
    this.content$ = content;
    this.show$ = true;
  };

  @action
  closeAlert = (): void => {
    this.content$.onIgnore && this.content$.onIgnore();
    this.reset();
  };
}
